// Shared "running total" panel for all BD lens-selection modals. Keeps the
// frame price plus every selected add-on visible on the left while the
// customer moves through the steps on the right.
window.BdWizSummary = (function () {
  function fmtPrice(price) {
    const n = parseFloat(price);
    if (isNaN(n)) return "";
    if (n === 0) return "Inklusive";
    return "+ CHF " + n.toFixed(2);
  }

  // modalId: e.g. "bdLensModal" — expects #{modalId}SummaryList and
  // #{modalId}SummaryTotal in the DOM (rendered by bd-wizard-shell.liquid).
  function mount(modalId, basePrice, baseLabel) {
    const list = document.getElementById(modalId + "SummaryList");
    const totalEl = document.getElementById(modalId + "SummaryTotal");
    if (!list || !totalEl) return null;

    const items = {};

    function render() {
      list.innerHTML = "";
      const rows = [{ key: "_base", label: baseLabel, price: basePrice }].concat(
        Object.keys(items).map((k) => Object.assign({ key: k }, items[k]))
      );
      let total = 0;
      rows.forEach((r) => {
        total += parseFloat(r.price) || 0;
        const row = document.createElement("div");
        row.className = "bd-wiz-sumrow";
        const label = document.createElement("span");
        label.className = "bd-wiz-sumrow__label";
        label.textContent = r.label;
        const price = document.createElement("span");
        price.className = "bd-wiz-sumrow__price";
        price.textContent = fmtPrice(r.price);
        row.appendChild(label);
        row.appendChild(price);
        list.appendChild(row);
      });
      totalEl.textContent = "CHF " + total.toFixed(2);
    }

    render();

    return {
      set(key, label, price) {
        items[key] = { label, price };
        render();
      },
      clear(key) {
        delete items[key];
        render();
      },
      reset() {
        Object.keys(items).forEach((k) => delete items[k]);
        render();
      },
    };
  }

  return { mount };
})();

// Keep the wizard's "shopwindow" product photo + variant subtitle in sync
// with the product page's color/variant picker. bd-wizard-shell.liquid only
// renders once server-side at page load, so without this the modal kept
// showing whichever variant was selected when the page first loaded, even
// after the customer picked a different color.
document.addEventListener("DOMContentLoaded", function () {
  if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    const variant = event && event.data && event.data.variant;
    if (!variant) return;
    document.querySelectorAll(".bd-wiz-modal").forEach(function (modal) {
      const img = modal.querySelector(".bd-wiz-product img");
      if (img) {
        const src = (variant.featured_image && variant.featured_image.src) || modal.dataset.defaultImage;
        if (src) img.src = src;
      }
      const sub = modal.querySelector(".bd-wiz-product__sub");
      if (sub) {
        if (variant.title && variant.title !== "Default Title") {
          sub.textContent = variant.title;
          sub.style.display = "";
        } else {
          sub.style.display = "none";
        }
      }
    });
  });
});

// Generic accordion for the "Glasdetails" dropdown attached under each
// lens-option row (.bd-wiz-rowgroup) — reusable by any BD wizard modal.
document.addEventListener("click", function (e) {
  const toggle = e.target.closest(".bd-wiz-row__details-toggle");
  if (!toggle) return;
  e.preventDefault();
  e.stopPropagation();
  const panel = document.getElementById(toggle.getAttribute("aria-controls"));
  if (!panel) return;
  const isOpen = toggle.getAttribute("aria-expanded") === "true";
  toggle.setAttribute("aria-expanded", String(!isOpen));
  panel.classList.toggle("is-open", !isOpen);
});
